import { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { DashboardProvider } from "../../context/DashboardContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import AdminPanel from "../dashboard/AdminPanel";
import { LayoutDashboard, Layers, GitCompareArrows, Table2, Sparkles, Wallet, Building2, Gauge, Database, Target, FolderCog } from "lucide-react";

const MOBILE_NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/services", label: "Services", icon: Layers },
  { to: "/platforms", label: "Platforms", icon: GitCompareArrows },
  { to: "/campaigns", label: "Campaigns", icon: Table2 },
  { to: "/revenue", label: "Revenue", icon: Wallet },
  { to: "/ai", label: "AI", icon: Sparkles },
  { to: "/branches", label: "Branches", icon: Building2 },
  { to: "/mgmt", label: "Mgmt", icon: Gauge },
  { to: "/daily-funnel", label: "Funnel", icon: Database },
  { to: "/goals", label: "Goals", icon: Target },
  { to: "/master-data", label: "Masters", icon: FolderCog },
];

export default function DashboardLayout() {
  const { user } = useAuth();
  const [adminOpen, setAdminOpen] = useState(false);
  const isAdmin = user?.role === "admin";

  return (
    <DashboardProvider>
      <div className="min-h-screen bg-[#0F172A] text-white flex">
        <Sidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <Topbar onOpenAdmin={() => setAdminOpen(true)} isAdmin={isAdmin} />
          {/* Mobile nav */}
          <div className="lg:hidden flex gap-1 overflow-x-auto px-3 py-2 border-b border-white/10 bg-[#0B1120]">
            {MOBILE_NAV.map((n) => {
              const Icon = n.icon;
              return (
                <NavLink key={n.to} to={n.to} end={n.end}
                  className={({ isActive }) =>
                    `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors ${
                      isActive ? "bg-[#38BDF8] text-[#0F172A]" : "text-slate-400 bg-[#1E293B]"}`}>
                  <Icon className="w-3.5 h-3.5" /> {n.label}
                </NavLink>
              );
            })}
          </div>
          <main className="flex-1 p-4 md:p-6">
            <div className="max-w-[1500px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
        <AdminPanel open={adminOpen} onOpenChange={setAdminOpen} />
      </div>
    </DashboardProvider>
  );
}
